<template>
  <div class="wc-tab">
    <load-state :state="state" empty-text="暂无球队数据" @retry="load(false)">
      <div class="wc-team-tip">选择一支球队，查看小组排名与赛程</div>
      <div v-for="group in groups" :key="group.team_group" class="wc-team-group">
        <div class="wc-team-group__title">
          <span class="wc-team-group__letter">{{ group.team_group }}</span>
          <span class="wc-team-group__word">组</span>
        </div>
        <div class="wc-team-grid">
          <button
            v-for="team in sortedTeams(group.team_rank)"
            :key="team.id"
            class="wc-team-item"
            @click="goTeam(team.id)"
          >
            <team-logo :src="team.team_logo" :name="team.team_name" />
            <span>{{ team.team_name }}</span>
            <i></i>
          </button>
        </div>
      </div>
    </load-state>
  </div>
</template>

<script>
import { getRank } from '@/api/worldcup2026'
import LoadState from '../components/LoadState.vue'
import TeamLogo from '../components/TeamLogo.vue'
import { worldcupCache } from '../utils/cache'

export default {
  name: 'WorldCupTeamTab',
  components: { LoadState, TeamLogo },
  data () {
    return {
      state: 'idle',
      groups: []
    }
  },
  created () {
    this.load(true)
  },
  methods: {
    async load (useCache = true) {
      if (useCache && worldcupCache.rank) {
        this.applyRank(worldcupCache.rank)
        return
      }
      this.state = 'loading'
      try {
        const resp = await getRank()
        if (resp.error_code !== 0) {
          this.state = 'error'
          return
        }
        const groups = resp.result && resp.result.data ? resp.result.data : []
        worldcupCache.rank = groups
        this.applyRank(groups)
      } catch (e) {
        this.state = 'error'
      }
    },
    applyRank (groups) {
      this.groups = groups
      this.state = groups.length ? 'success' : 'empty'
    },
    sortedTeams (teams) {
      return [...(teams || [])].sort((a, b) => Number(a.rank || 0) - Number(b.rank || 0))
    },
    goTeam (id) {
      const query = this.$route.query.screen ? { screen: this.$route.query.screen } : {}
      this.$router.push({ path: `/worldcup2026/team/${id}`, query })
    }
  }
}
</script>

<style scoped lang="scss">
.wc-tab {
  padding: 12px;
}

.wc-team-tip {
  margin-bottom: 12px;
  color: #6b7280;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
  word-break: normal;
}

.wc-team-group {
  margin-bottom: 12px;
  border: 1px solid #dce1eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.wc-team-group__title {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 14px;
  background: #f0f2f7;
}

.wc-team-group__letter {
  margin-right: 3px;
  color: #deba40;
  font-size: 22px;
  line-height: 22px;
  font-weight: 900;
}

.wc-team-group__word {
  color: #4a5568;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
}

.wc-team-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.wc-team-item {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 50px;
  padding: 0 12px;
  border: 0;
  background: #ffffff;
}

.wc-team-item:nth-child(2n + 1) {
  border-right: 1px solid #edf0f3;
}

.wc-team-item:nth-child(n + 3) {
  border-top: 1px solid #edf0f3;
}

.wc-team-item span {
  flex: 1;
  min-width: 0;
  margin-left: 8px;
  color: #1a1a1a;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wc-team-item i {
  width: 8px;
  height: 8px;
  border-right: 1px solid #9aa0a6;
  border-bottom: 1px solid #9aa0a6;
  transform: rotate(-45deg);
}
</style>
